import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import I18nextBrowserLanguageDetector from "i18next-browser-languagedetector";

i18next
  .use(initReactI18next)
  .use(I18nextBrowserLanguageDetector)
  .init({
    fallbackLng: 'en',
    resources: {
        en: {
            translation: {
                introHead: 'Discover New Mangas With SNIIP',
                introSmall: 'Be the first to be notified of our launch!',
                inputEmail: 'Enter email',
                statsTitle: "What's Happening Now?",
                statsSubtitle: "A Small Market",
                statsP: "Overall only <strong>15-20%</strong> of manga is available to english<br></br>speaking audiences.",
                whyUsTitle: 'Why Us',
                whyUsP: "We want our reader to read mangas for free while legally supporting authors. Our team aims to create a centralized library to house these translated stories.",
                ourPlanTitle: "Our Plan",
                ourPlanCardSubtitle: "Freemium model",
                ourPlanCardTitle: "Access Free of Charge",
                ourPlanLi1: "Access titles never released before in English",
                ourPlanLi2: "Free daily chapters",
                ourPlanLi3: "Save your favorite works",
                ourPlanLi4: "Share your thoughts and leave comments",
                ourPlanLi5: "Additional access to premium features/content through store currency and ads",
                faqTitle: "Frequently Asked Questions",
                faqQ1: "When are you planning to launch?",
                faqA1: "We are planning for a mid 2023 launch with an app release soon after!",
                faqQ2: "Can I read everything here for free?",
                faqA2: "We will have free content! Our aspiration is to make new manga as accessible as possible. Generally, users will be able to read our content completely free of charge as Sniip will hand out a free chapter for each series every day. This may be subject to the wishes of the publishers and authors.",
                faqQ3: "What types of titles will be offered?",
                faqA3: "We are planning to have titles from many publishers and authors. We're not planning to focus on one genre right now (as long as they're SFW).  We are currently focusing on translating and releasing titles from private authors and more lowkey publishers, something that even the most avid manga readers may not have seen yet!",
                faqQ4: "Why did we found Sniip?",
                faqA4: "We started this service after seeing problems with the current manga market. We've used plenty of other websites, but after experiencing poor translation and website up-times, we've had enough. We want to make a completely legal service that is accessible to everyone and will rarely go down.  We hope to continue to improve with time, and of course to provide professionally translated and edited works as well.",
                outro: "Interested in<br></br>Finding out more?"
            }
        },
        jp: {
            translation: {
                introHead: 'SNIIPで漫画を世界へ!',
                introSmall: '最新情報の受け取りはこちらから！',
                inputEmail: 'メール入力',
                statsTitle: "限られた市場",
                statsSubtitle: "限られた市場",
                statsP: "英語圏のユーザーがアクセスできる漫画は日本の<strong>15～20％</strong>に過ぎない",
                whyUsTitle: 'なぜSNIIP',
                whyUsP: "作者と連絡を取り合い、海外配信に最適な翻訳を目指します。",
                ourPlanTitle: "海外ユーザー向けプラン",
                ourPlanCardSubtitle: "ユーザープラン",
                ourPlanCardTitle: "チケット制",
                ourPlanLi1: "英語圏に進出していない漫画へのアクセス",
                ourPlanLi2: "待てば無料システム",
                ourPlanLi3: "好きな作品を本棚にキープ",
                ourPlanLi4: "コメントで作品の感想を共有",
                ourPlanLi5: "アプリ・ウェブサイト内の通貨でさらに多くの作品へアクセス",
                faqTitle: "よくある質問",
                faqQ1: "サービス展開はいつごろから始まるの？",
                faqA1: "SNIIP　Manga の配信開始日程は2023年4〜5月を想定しています。",
                faqQ2: "全ての作品を無料で閲覧可能なの？",
                faqA2: "出版社や作者の希望によって閲覧可能な日程が異なる可能性はありますが、現在すべての作品は待てば無料による閲覧が可能です。",
                faqQ3: "どのような作品を配信するの？",
                faqA3: "我々の目標は海外における漫画配信の中枢となるようなプラットフォームを作成することです。多様な需要に合わせるため、ジャンルにとらわれず様々な作品を配信する予定です。",
                faqQ4: "なぜこのサービスを始めたの？",
                faqA4: "私がこのサービスを始めたきっかけはアメリカの映画館で鑑賞した「千と千尋の神隠し」（またはアニメ映画）がきっかけです。私は日本の文化、言語を知らない人たちが映画を見て笑い、悲しみ、楽しむ様を目の当たりにしました。その時言語・文化を知らなくても人の夢と幻想は国境を越えることができると気づき、感銘を受けました。日本には国境を越えることを待っている作品がまだ多く存在しています。その中で特に私は漫画家の皆様が人生を欠けて書いた作品が日本に留まっていることに疑問を抱きました。この現状を変えるために、感動を世界に届けるためにＳＮＩＩＰを設立しました。",
                outro: "お気軽にご相談ください！"
            }
        }
    }
  })